<template>
  <div class="subscriptions-page">
    <!-- 全局loadingView -->
    <div v-if="showLoading" class="global-loading-view">
      <div class="loading-content">
        <div class="spinner"></div>
        <p>{{ $i18n.t("subscription.loading_txt") }}</p>
      </div>
    </div>

    <div v-if="loading" class="loading">
      <div class="spinner"></div>
      <p>{{ $i18n.t("subscription.loading_txt") }}</p>
    </div>

    <div v-else>
      <div class="header">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; position: fixed; top: 16px; left: 10px;">
          <div class="brand-header" @click="goToHome">
            <v-img 
              :src="require('@/assets/logo.png')" 
              max-height="60px" 
              max-width="60px" 
              alt="logo" 
              contain
              class="brand-logo"
            ></v-img>
            <!-- <div class="brand-title">
              {{ $i18n.t("welcome.product_name") }}
              <span class="tm-mark">TM</span>
            </div> -->
          </div>
          <div style="font-size: 12px;" >{{ $i18n.t("subscription.go_to_office_web_txt") }}</div>
        </div>
        <h1>{{ $i18n.t("subscription.home_title_txt") }}</h1>
        <div class="nav-buttons">
          <button 
            class="nav-btn" 
            :class="{ 'active': activeTab === 'my-subscriptions' }"
            @click="toMySubscriptions()"
          >
            {{ $i18n.t("subscription.home_tab_my_subscription_txt") }}
          </button>
          <button 
            class="nav-btn" 
            :class="{ 'active': activeTab === 'buy-subscriptions' }"
            @click="toBuySubscriptions()"
          >
            {{ $i18n.t("subscription.home_tab_buy_subscription_txt") }}
          </button>
        </div>
        <button @click="downloadFile" class="glass-download-btn">
          <svg class="glass-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <defs>
              <filter id="glassFilter">
                <feGaussianBlur in="SourceGraphic" stdDeviation="1"/>
                <feColorMatrix type="matrix" values="1 0 0 0 0.2  0 1 0 0 0.2  0 0 1 0 0.2  0 0 0 0.2 0"/>
              </filter>
            </defs>
            <circle cx="12" cy="12" r="10" fill="rgba(255,255,255,0.15)" filter="url(#glassFilter)"/>
            <path d="M12 16L12 4M12 16L8 12M12 16L16 12" stroke="white" stroke-width="2" stroke-linecap="round"/>
            <path d="M4 20H20" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
          {{ $i18n.t("subscription.download_app_btn_txt") }}
        </button>
        <button v-if="showUsageRecordsBtn" @click="goToUsageRecords" class="glass-download-btn" style="right: 300px;" >
          Usage Records
        </button>
      </div>
      <SubscriptionStats :stats="userStats" />
      <ProductsPage v-show="showProductsPage" />
      <SubscriptionList v-show="showMySubscriptions" :subscriptions="subscriptions" />
      <LogoutDrawer style="position: fixed; top: 8px; right: 10px;" @logout="goBack" />
    </div>
  </div>
</template>

<script>
import { i18n } from "@/plugins/i18n.js";
import { userKeys, wdConfigData } from "@/service/wd_app_config.js";
import { resetAllModulesState } from "@/store/modules/index.js"
import LogoutDrawer from '@/components/LogoutDrawer.vue';
import SubscriptionStats from '../components/subscriptionStats.vue';
import ProductsPage from '../components/productsPage.vue';
import SubscriptionList from '../components/subscriptionList.vue';
import { api_get_subscription_balance, api_get_user_sbuscription_purchase_records, subscriptionApi } from '../services/subscriptionApi.js';

export default {
  name: 'SubscriptionsPage',
  components: {
    LogoutDrawer,
    SubscriptionStats,
    ProductsPage,
    SubscriptionList
  },
  data() {
    return {
      loading: true,
      showLoading: false,
      userStats: {
        total: 0,
        used: 0,
        remaining: 0
      },
      subscriptions: [],
      showProductsPage: false,
      showMySubscriptions: true,
      activeTab: 'my-subscriptions', // 当前选中的标签页
      clickLogOutBtnTime: null,
      showUsageRecordsBtn: false, // 是否显示使用记录按钮
    };
  },
  async mounted() {
    i18n.locale = wdConfigData.localLanguage
    // 检查路由参数来确定默认选中的标签页
    this.initActiveTab();
    await this.loadData();

    // 只有登录的用户名等于bo@nextmind.com的时候，才显示showUsageRecordsBtn
    var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
    console.log('Current user:', user);
    if (user && (user.Id === "3551481ab61d49b79175ad4b234670ca" || user.Id === "3551481ab61d49b7819686bba06575e8")) {
      this.showUsageRecordsBtn = true;
    }
  },
  methods: {
    goToHome() {
      window.open('https://www.nextmindapp.com/', '_blank', 'noopener,noreferrer')
    },
    downloadFile() {
      window.open('https://www.nextmindapp.com/', '_blank', 'noopener,noreferrer')
    },
    goToUsageRecords() {
      this.$router.push({ name: 'usage-records' });
    },
    initActiveTab() {
      // 从路由查询参数中获取 tab 参数，如果没有则默认为 'my-subscriptions'
      const tab = this.$route.query.tab || 'my-subscriptions';
      
      if (tab === 'buy-subscriptions') {
        this.activeTab = 'buy-subscriptions';
        this.showMySubscriptions = false;
        this.showProductsPage = true;
      } else {
        this.activeTab = 'my-subscriptions';
        this.showMySubscriptions = true;
        this.showProductsPage = false;
      }
    },
    toMySubscriptions() {
      this.activeTab = 'my-subscriptions';
      this.showMySubscriptions = true;
      this.showProductsPage = false;
      
      // 更新路由查询参数（可选，用于保持状态）
      if (this.$route.query.tab !== 'my-subscriptions') {
        this.$router.replace({ 
          path: this.$route.path, 
          query: { ...this.$route.query, tab: 'my-subscriptions' } 
        });
      }
    },
    toBuySubscriptions() {
      this.activeTab = 'buy-subscriptions';
      this.showMySubscriptions = false;
      this.showProductsPage = true;
      
      // 更新路由查询参数（可选，用于保持状态）
      if (this.$route.query.tab !== 'buy-subscriptions') {
        this.$router.replace({ 
          path: this.$route.path, 
          query: { ...this.$route.query, tab: 'buy-subscriptions' } 
        });
      }
    },
    async loadData() {
      this.showLoading = true;
      try {
        var that = this;
        // const data = await subscriptionApi.getUserSubscriptions();
        api_get_subscription_balance().then(
          (response) => {
            if (response.data.Code === 0) {
              that.handleGetSubscriptionBalanceResponse(response);
            } else {
              that.showLoading = false;
              console.error('Failed to get subscription balance:', response.data.Message);
            }
          },
          (error) => {
            that.showLoading = false;
            console.error('Error fetching subscription balance:', error);
          }
        );
        // 暂时不需要通过record来获取订阅记录，因为企业分配的订阅可能查不到
        // api_get_user_sbuscription_purchase_records().then(
        //   (response) => {
        //     if (response.data.Code === 0) {
        //       that.handleGetSubscriptionPurchaseRecordsResponse(response);
        //     } else {
        //       console.error('Failed to get subscription purchase records:', response.data.Message);
        //     }
        //   },
        //   (error) => {
        //     console.error('Error fetching subscription purchase records:', error);
        //   }
        // );
        // this.userStats = {
        //   total: data.total,
        //   used: data.used,
        //   remaining: data.remaining
        // };
        // this.subscriptions = data.subscriptions;
      } catch (error) {
        console.error('Failed to load subscriptions:', error);
      } finally {
        this.loading = false;
      }
    },
    handleGetSubscriptionBalanceResponse(response) {
      if (response.data.Code === 0) {
        this.userStats.total = response.data.Result.TotalAmount;
        this.userStats.used = response.data.Result.UsedAmount;
        this.userStats.remaining = response.data.Result.BalanceAmount;
      } else {
        console.error('Failed to get subscription balance:', response.data.Description);
      }
      this.handleGetSubscriptionPurchaseRecordsResponse(response);
    },
    handleGetSubscriptionPurchaseRecordsResponse(response) {
      this.showLoading = false;
      if (response.data.Code === 0) {
        this.subscriptions = response.data.Result.Subscriptions;
        // var subscriptionMap = {};
        this.subscriptions.forEach(subscription => {
          switch (subscription.Status) {
            case 1:
              subscription.Status = 'active';
              break;
            case 2:
              subscription.Status = 'expired';
              break;
            case 0:
              subscription.Status = 'pending';
              break;
            default:
              subscription.Status = 'pending';
          }
          const dateFields = ['StartTime', 'EndTime'];
          dateFields.forEach(field => {
            if (subscription[field]) {
              const date = new Date(subscription[field]);
              if (!isNaN(date.getTime())) {
                // 手动加上 UTC+8 的时间偏移（8 * 60 * 60 * 1000 毫秒）
                const offsetDate = new Date(date.getTime() + 8 * 60 * 60 * 1000);
                subscription[field] = offsetDate.toISOString().split('T')[0];
              }
            }
          });
          // subscriptionMap = subscription || {};
        });

        // // 模拟数据填充
        // for (let i = 0; i < 30; i++) {
        //   this.subscriptions.push(subscriptionMap);
        // }
      } else {
        console.error('Failed to get subscription purchase records:', response.data.Description);
      }
    },
    goBack() {
      this.logout()
      // const now = new Date().getTime()
      // if (this.clickLogOutBtnTime === null) {
      //   this.clickLogOutBtnTime = now
      //   this.$message.warning(i18n.t("ppt_add_in_main.logout_time_remind"))
      // } else {
      //   const timeDifference = now - this.clickLogOutBtnTime
      //   if (timeDifference <= 5000) {
      //     this.clickLogOutBtnTime = null
      //     this.logout()
      //   } else {
      //     this.$message.warning(i18n.t("ppt_add_in_main.logout_time_remind"))
      //     this.clickLogOutBtnTime = now
      //   }
      // }
    },
    logout() {
      localStorage.clear()
      resetAllModulesState()
      this.$router.replace("/welcome");
    },
  }
}
</script>

<style scoped>
.subscriptions-page {
  position: relative;
}

.brand-header {
  display: flex;
  align-items: center;
}

.brand-logo {
  margin-right: 6px;
}

.brand-title {
  font-size: 20px;
  font-weight: 600;
  position: relative;
  padding-right: 20px;
}

.tm-mark {
  position: absolute;
  top: -4px;
  right: 0;
  font-size: 12px;
  font-weight: normal;
  opacity: 0.8;
}

.glass-download-btn {
  position: fixed;
  top: 55px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.glass-download-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

/* 全局loadingView样式 */
.global-loading-view {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* 半透明背景 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* 确保在最上层 */
}

.global-loading-view .loading-content {
  text-align: center;
  background: rgba(255, 255, 255, 0.9);
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.global-loading-view .spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

.back-btn {
  position: fixed;
  top: 5px;
  right: 10px;
  /* width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  color: #667eea;
  z-index: 1000; */
}

.back-btn:hover {
  background: white;
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.back-btn:active {
  transform: scale(0.95);
}

.loading {
  text-align: center;
  padding: 50px;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 15px 0;
  /* margin-bottom: 8px; */
  border-radius: 0 0 0 0;
}

.header h1 {
  text-align: center;
  font-size: 18px;
  margin-bottom: 20px;
}

.nav-buttons {
  /* display: flex;
  justify-content: space-between;
  margin: 0 20px; */
  text-align: center;
  /* margin-top: 20px; */
}

.nav-btn {
  background: rgba(255, 255, 255, 0.2);
  font-size: 13px;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 5px 24px;
  margin: 0 20px;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  display: inline-block;
}

.nav-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* 选中状态样式 */
.nav-btn.active {
  background: rgba(255, 255, 255, 0.9);
  color: #667eea;
  border-color: rgba(255, 255, 255, 0.9);
  font-weight: bold;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* 选中状态的悬停效果 */
.nav-btn.active:hover {
  background: white;
  color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
}
</style>